import React, { useContext } from 'react'
import { DummyHeader } from '../components/DummyHeader'
import { TranslationContext } from '~/contexts/TranslationContext'

export const HeaderContainer = ({ type }) => {
  const { t } = useContext(TranslationContext)
  return (
    <DummyHeader type={type} caption={t('TEXT_HEADER_TEXT_CAPTION_TEXT')} />
  )
}
